import { render, staticRenderFns } from "./MAppAccount.vue?vue&type=template&id=2e2e8ac4"
import script from "./MAppAccount.vue?vue&type=script&lang=ts"
export * from "./MAppAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AAvatar: require('/codebuild/output/src88717421/src/app/components/atoms/AAvatar.vue').default,AIcon: require('/codebuild/output/src88717421/src/app/components/atoms/Media/AIcon.vue').default,AGapText: require('/codebuild/output/src88717421/src/app/components/atoms/AGapText.vue').default,AMenu: require('/codebuild/output/src88717421/src/app/components/atoms/Menu/AMenu.vue').default})
